import { analyticsVariants, routeToPageLayerV2 } from 'mappers/routes';
import { specialWaitings } from 'constants/mission';

export const getRouteDataV2 = (
  route,
  customRoutePageLayer = {},
  relevantData = {},
) => {
  const customRoutes = {};
  Object.keys(customRoutePageLayer).forEach(key => {
    const { edit } = analyticsVariants;
    const customStepsVariants = { edit };
    const customStepAnalyticsVariants = customRoutePageLayer[key][3];
    if (customStepAnalyticsVariants !== null) {
      const variants = customStepAnalyticsVariants.split(',');
      variants.forEach(variant => {
        if (analyticsVariants[variant]) {
          customStepsVariants[variant] = analyticsVariants[variant];
        }
      });
    }
    customRoutes[key] = [
      customRoutePageLayer[key][0],
      customRoutePageLayer[key][1],
      customStepsVariants,
    ];
  });
  const allRoutesToPageLayer = {
    ...routeToPageLayerV2,
    ...customRoutes,
  };
  const { dtStep, variant } = relevantData;
  const [page_name, step_name, extra_data_layer] =
    allRoutesToPageLayer[route] || routeToPageLayerV2['not-found'];
  const { prefix, ...variantDatalayer } = extra_data_layer?.[variant] || {};
  let finalPageName = page_name;
  const dtData = {};
  if (prefix) {
    finalPageName = prefix + finalPageName;
  }
  if (extra_data_layer?.showDTCurrentStep) {
    finalPageName = finalPageName + `-step${dtStep}`;
    dtData.tree_questionnaire_step = dtStep;
  }
  return {
    page_name: finalPageName,
    step_name,
    ...variantDatalayer,
    ...dtData,
    ...(extra_data_layer?.customDatalayer || {}),
  };
};

const ACCEPTABLE_DESCRIPTIONS = ['WAITING', ...specialWaitings];

export const getEventCategoryV2 = (type, description) => {
  const route =
    type === 'WAITING' && ACCEPTABLE_DESCRIPTIONS.includes(description)
      ? description || type
      : type;
  const [eventcategory] =
    routeToPageLayerV2[route] || routeToPageLayerV2['not-found'];
  return eventcategory;
};
